
        var result = require("!!../../../../../node_modules/css-loader/index.js!./gastwo-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/gas-two/gastwo-statistics/gastwo-statistics.component.css
// module id = 784
// module chunks = 0